import React from 'react'
import { Col, Row } from 'react-bootstrap'
import Image from 'components/Image'
import { ICommonProductListItemProps } from '../IProductListItemProps'

interface IProductItemHeaderWithImageProps extends ICommonProductListItemProps {}

const ProductItemHeaderWithImage: React.FC<IProductItemHeaderWithImageProps> = ({
  product,
  children,
}) => {
  return (
    <>
      <Col xs={12} sm={4} md={4}>
        <Image
          url={product.images && product.images.length > 0 ? product.images[0].url : ''}
        />
      </Col>

      <Col xs={12} sm={8} md={8}>
        <Row className='gy-3'>
          <Col xs={12}>
            <div className='big-product-name-font' style={{ textAlign: 'left' }}>
              {product.name}
            </div>
          </Col>

          {children}
        </Row>
      </Col>
    </>
  )
}
export default ProductItemHeaderWithImage
